export const LEGAL = {
  privacy: {
    en: {
      title: "Privacy Policy",
      updated: "Last updated: June 2026",
      sections: [
        {
          heading: "Who we are",
          body: "IndiaFees (indiafees.com) is an independent directory that provides links to official Tamil Nadu Government payment portals. We are not affiliated with the Government of Tamil Nadu or the Government of India, and we do not process payments.",
        },
        {
          heading: "What we collect",
          body: "IndiaFees is a link directory. We do not ask for Aadhaar, bank details, or payment information on this site — those are entered only on official government portals after you leave IndiaFees. We also do not collect debit card, credit card, UPI, net banking or other payment credentials. If you choose to create an optional member account, we store your name and email address so you can sign in. We do not sell this information.",
        },
        {
          heading: "Member accounts",
          body: "Sign-up is optional. Account data (name, email, and a securely hashed password) is stored on our servers only to provide login, password reset, and account management. You can contact us to ask about your account data. You may request deletion of your account at any time by contacting us.",
        },
        {
          heading: "Local storage",
          body: "Your language preference (English or Tamil) may be saved in your browser’s local storage so the site opens in your chosen language on your next visit. You can clear this anytime through your browser settings.",
        },
        {
          heading: "Third-party sites",
          body: "When you click a payment link, you leave IndiaFees and go to an official government website or other authorised payment portal. Those sites have their own privacy policies. We are not responsible for how they handle your data.",
        },
        {
          heading: "Analytics",
          body: "We may use privacy-friendly analytics to understand overall website usage. We do not use analytics to identify individual users.",
        },
        {
          heading: "Contact",
          body: "Privacy questions: contact@indiafees.com",
        },
      ],
    },
    ta: {
      title: "தனியுரிமைக் கொள்கை",
      updated: "கடைசியாக புதுப்பிக்கப்பட்டது: ஜூன் 2026",
      sections: [
        {
          heading: "நாங்கள் யார்",
          body: "IndiaFees (indiafees.com) என்பது தமிழ்நாட்டிற்கான அதிகாரப்பூர்வ அரசு கட்டண வலைத்தளங்களின் இணைப்புகளை வழங்கும் ஒரு சுயாதீன இணையதளம். மின்சாரம், சொத்து வரி, குடிநீர், அரசு கட்டணங்கள் மற்றும் அபராதங்களுக்கான சரியான அதிகாரப்பூர்வ இணையதளங்களை எளிதாகக் கண்டறிய உதவுகிறோம். நாங்கள் அரசு அமைப்பு அல்ல; எந்தக் கட்டணத்தையும் வசூலிக்க மாட்டோம்.",
        },
        {
          heading: "நாங்கள் சேகரிக்கும் தகவல்கள்",
          body: "IndiaFees ஒரு இணைப்பு வழிகாட்டி இணையதளம். இந்த தளத்தில் ஆதார் எண், வங்கி விவரங்கள், UPI, டெபிட் கார்டு, கிரெடிட் கார்டு அல்லது பிற கட்டணத் தகவல்களை நாங்கள் கேட்கவோ சேமிக்கவோ மாட்டோம். இத்தகவல்கள் அதிகாரப்பூர்வ அரசு வலைத்தளங்களில் மட்டுமே உள்ளிடப்பட வேண்டும். விருப்பப்பட்டால் உறுப்பினர் கணக்கை உருவாக்கலாம். அதற்காக உங்கள் பெயர் மற்றும் மின்னஞ்சல் முகவரி மட்டும் சேமிக்கப்படும். இந்தத் தகவல்கள் எந்த மூன்றாம் தரப்பினருக்கும் விற்கப்படவோ பகிரப்படவோ மாட்டாது.",
        },
        {
          heading: "உறுப்பினர் கணக்கு",
          body: "உறுப்பினர் பதிவு செய்வது கட்டாயமல்ல. உள்நுழைவு, கடவுச்சொல் மாற்றம் மற்றும் கணக்கு நிர்வாகத்திற்காக மட்டுமே உங்கள் பெயர், மின்னஞ்சல் முகவரி மற்றும் பாதுகாப்பாக குறியாக்கப்பட்ட கடவுச்சொல் சேமிக்கப்படும். உங்கள் கணக்கு தொடர்பான கேள்விகளுக்கு contact@indiafees.com என்ற மின்னஞ்சல் முகவரியில் எங்களைத் தொடர்புகொள்ளலாம். எந்த நேரத்திலும் எங்களைத் தொடர்புகொண்டு உங்கள் கணக்கை நீக்குமாறு கோரலாம்.",
        },
        {
          heading: "உலாவி சேமிப்பு (Local Storage)",
          body: "நீங்கள் தேர்வு செய்த மொழி (தமிழ் அல்லது English) உங்கள் உலாவி சேமிப்பில் (Local Storage) சேமிக்கப்படலாம். இதனால் அடுத்த முறை தளம் நீங்கள் தேர்வு செய்த மொழியிலேயே திறக்கும். விரும்பினால், இதை உங்கள் உலாவி அமைப்புகளில் இருந்து எப்போது வேண்டுமானாலும் நீக்கலாம்.",
        },
        {
          heading: "வெளிப்புற இணையதளங்கள்",
          body: "IndiaFees-இல் உள்ள இணைப்புகளைத் திறந்தால், நீங்கள் அதிகாரப்பூர்வ அரசு வலைத்தளம் அல்லது அங்கீகரிக்கப்பட்ட கட்டண இணையதளத்திற்குச் செல்லுவீர்கள். அந்த இணையதளங்களின் தனியுரிமைக் கொள்கை, பயன்பாட்டு நிபந்தனைகள் மற்றும் தகவல் கையாளும் நடைமுறைகள் தனித்தனியாக இருக்கும்.",
        },
        {
          heading: "பயன்பாட்டுப் பகுப்பாய்வு",
          body: "ஒட்டுமொத்த இணையதளப் பயன்பாட்டைப் புரிந்துகொள்ள, தனியுரிமைக்கு உகந்த பகுப்பாய்வைப் பயன்படுத்தலாம். தனிப்பட்ட பயனர்களை அடையாளம் காண பகுப்பாய்வைப் பயன்படுத்த மாட்டோம்.",
        },
        {
          heading: "தொடர்பு",
          body: "தனியுரிமை தொடர்பான கேள்விகளுக்கு: contact@indiafees.com",
        },
      ],
    },
  },
  terms: {
    en: {
      title: "Terms of Use",
      updated: "Last updated: June 2026",
      sections: [
        {
          heading: "Acceptance",
          body: "By accessing or using IndiaFees, you agree to these Terms of Use. If you do not agree, please do not use the website.",
        },
        {
          heading: "What IndiaFees provides",
          body: "IndiaFees is an independent directory that helps users find official government payment portals. We do not collect payments, issue receipts, or act as a payment gateway or intermediary.",
        },
        {
          heading: "Your responsibility",
          body: "Always verify that you are on the correct official website before entering personal or payment details. Check the URL, SSL certificate, and government branding on the destination site.",
        },
        {
          heading: "Link accuracy",
          body: "We review links regularly but cannot guarantee every URL is always correct, online, or unchanged. Government portals may move or update without notice.",
        },
        {
          heading: "No professional advice",
          body: "Information on IndiaFees is for general directory purposes only. It is not legal, tax, or financial advice.",
        },
        {
          heading: "Limitation of liability",
          body: "IndiaFees is not responsible for any loss, damage, or inconvenience resulting from the use of third-party websites, incorrect information, unavailable services, or changes made by government authorities.",
        },
        {
          heading: "Changes",
          body: "We may update these terms or the link directory at any time. Continued use of the site means you accept the updated terms.",
        },
      ],
    },
    ta: {
      title: "பயன்பாட்டு நிபந்தனைகள்",
      updated: "கடைசியாக புதுப்பிக்கப்பட்டது: ஜூன் 2026",
      sections: [
        {
          heading: "ஏற்பு",
          body: "IndiaFees இணையதளத்தைப் பயன்படுத்துவதன் மூலம், இந்த பயன்பாட்டு நிபந்தனைகளை நீங்கள் ஏற்றுக்கொள்கிறீர்கள். இவற்றை ஏற்கவில்லை என்றால், இந்த இணையதளத்தைப் பயன்படுத்த வேண்டாம்.",
        },
        {
          heading: "IndiaFees வழங்கும் சேவை",
          body: "IndiaFees என்பது தமிழ்நாடு மற்றும் மத்திய அரசின் அதிகாரப்பூர்வ கட்டண வலைத்தளங்களுக்கான இணைப்புகளை வழங்கும் ஒரு சுயாதீன இணையதளம். சரியான அதிகாரப்பூர்வ இணையதளத்தை கண்டறிய உதவுகிறோம். நாங்கள் எந்தக் கட்டணத்தையும் வசூலிக்க மாட்டோம். பணம் பெறவோ, ரசீது வழங்கவோ, கட்டண சேவையாகச் செயல்படவோ மாட்டோம்.",
        },
        {
          heading: "உங்கள் பொறுப்பு",
          body: "தனிப்பட்ட தகவல்கள் அல்லது கட்டண விவரங்களை உள்ளிடுவதற்கு முன், நீங்கள் அதிகாரப்பூர்வ அரசு வலைத்தளத்தில் இருப்பதை உறுதிப்படுத்திக் கொள்ள வேண்டும். இணையதள முகவரி (URL), பாதுகாப்பான இணைப்பு (HTTPS) மற்றும் அரசு அடையாளங்களைச் சரிபார்க்கவும்.",
        },
        {
          heading: "இணைப்புகளின் துல்லியம்",
          body: "எங்கள் இணையதளத்தில் உள்ள இணைப்புகளை அவ்வப்போது சரிபார்க்கிறோம். இருப்பினும், அனைத்து இணைப்புகளும் எப்போதும் செயல்பாட்டில் இருக்கும் அல்லது மாற்றமின்றி இருக்கும் என்று உத்தரவாதம் அளிக்க முடியாது. அரசு இணையதளங்கள் முன்னறிவிப்பின்றி மாற்றப்படலாம்.",
        },
        {
          heading: "தொழில்முறை ஆலோசனை அல்ல",
          body: "இந்த இணையதளத்தில் உள்ள தகவல்கள் பொதுவான வழிகாட்டல் நோக்கத்திற்காக மட்டுமே வழங்கப்படுகின்றன. இவை சட்ட, வரி, நிதி அல்லது தொழில்முறை ஆலோசனையாகக் கருதப்படக்கூடாது.",
        },
        {
          heading: "பொறுப்பு வரம்பு",
          body: "மூன்றாம் தரப்பு இணையதளங்களைப் பயன்படுத்துவதால், தவறான தகவல், சேவை இல்லாமை அல்லது அரசு மாற்றங்களால் ஏற்படும் நஷ்டம், சேதம் அல்லது சிரமத்திற்கு IndiaFees பொறுப்பல்ல.",
        },
        {
          heading: "மாற்றங்கள்",
          body: "இந்த பயன்பாட்டு நிபந்தனைகளையும் இணையதளத்தில் உள்ள தகவல்களையும் எப்போது வேண்டுமானாலும் மாற்றவோ புதுப்பிக்கவோ முடியும். மாற்றங்களுக்குப் பிறகும் இந்த இணையதளத்தை தொடர்ந்து பயன்படுத்துவது, அந்த மாற்றங்களை நீங்கள் ஏற்றுக்கொண்டதாகக் கருதப்படும்.",
        },
      ],
    },
  },
  contact: {
    en: {
      title: "Contact",
      updated: "We respond within 2–3 business days",
      sections: [
        {
          heading: "General enquiries",
          body: "Email: contact@indiafees.com — questions about IndiaFees, the directory, or how to use the site.",
        },
        {
          heading: "Report a broken or wrong link",
          body: "If a government payment link is broken, redirects to spam, or points to the wrong portal, email contact@indiafees.com with the department name, payment name, and the URL shown on IndiaFees. We treat suspicious redirects as urgent.",
        },
        {
          heading: "Privacy requests",
          body: "For privacy-related questions, use the same address with subject line “Privacy”.",
        },
        {
          heading: "Government departments",
          body: "IndiaFees is not operated by any government. For official service issues (bills, certificates, refunds), contact the relevant department portal or helpline directly.",
        },
        {
          heading: "Postal address",
          body: "IndiaFees / ASKQA — Tamil Nadu Government Payment Links Directory. Online service; correspondence by email preferred.",
        },
      ],
    },
    ta: {
      title: "தொடர்பு",
      updated: "2–3 வேலை நாட்களில் பதிலளிக்கிறோம்",
      sections: [
        {
          heading: "பொது விசாரணைகள்",
          body: "மின்னஞ்சல்: contact@indiafees.com — IndiaFees, அடைவு அல்லது தளப் பயன்பாடு பற்றிய கேள்விகள்.",
        },
        {
          heading: "தவறான/உடைந்த இணைப்பு தெரிவித்தல்",
          body: "அரசு கட்டண இணைப்பு உடைந்திருந்தால், ஸ்பேமுக்கு திருப்பினால் அல்லது தவறான தளம் என்றால் contact@indiafees.com-க்கு துறை பெயர், கட்டணப் பெயர், URL அனுப்புங்கள். சந்தேக இணைப்புகள் அவசரமாக கையாளப்படும்.",
        },
        {
          heading: "தனியுரிமை கோரிக்கைகள்",
          body: "தனியுரிமை தொடர்பான கேள்விகளுக்கு அதே முகவரியில் “Privacy” என்ற தலைப்பில் அனுப்புங்கள்.",
        },
        {
          heading: "அரசுத் துறைகள்",
          body: "IndiaFees எந்த அரசாலும் இயக்கப்படுவதில்லை. பணம், சான்றிதழ், திரும்பப்பெறுதல் போன்ற அதிகாரப்பூர்வ சேவைக்கு தொடர்புடைய துறை தளம்/ஹெல்ப்லைனை நேரடியாக அணுகுங்கள்.",
        },
        {
          heading: "அஞ்சல் முகவரி",
          body: "IndiaFees / ASKQA — தமிழ்நாடு அரசு கட்டண இணைப்புகள் அடைவு. ஆன்லைன் சேவை; மின்னஞ்சல் வழி தொடர்பு பரிந்துரைக்கப்படுகிறது.",
        },
      ],
    },
  },
  disclaimer: {
    en: {
      title: "Disclaimer",
      updated: "Please read carefully",
      sections: [
        {
          heading: "Not a government website",
          body: "IndiaFees is an independent private directory. It is not affiliated with, endorsed by, or operated by the Government of Tamil Nadu, Government of India, or any government department.",
        },
        {
          heading: "No payment handling",
          body: "IndiaFees does not collect, receive, process, store, or transmit any payments. All payments are made directly on official government websites or authorised payment portals. We are not a bank, wallet, or payment aggregator.",
        },
        {
          heading: "External links",
          body: "Links open in a new tab to external sites. We are not responsible for the content, availability, security, fees, or policies of those websites.",
        },
        {
          heading: "No warranty",
          body: "The directory is provided “as is” without warranty of any kind. We do not guarantee completeness, accuracy, or uninterrupted access.",
        },
        {
          heading: "Limitation of liability",
          body: "To the fullest extent permitted by law, IndiaFees and its operators are not liable for any loss or damage arising from use of this site or linked government portals, including payment errors, fraud on external sites, or outdated links.",
        },
        {
          heading: "Your due diligence",
          body: "Users are responsible for verifying that they are on the correct official website before entering personal or payment information. Always check the website address (URL), security certificate (HTTPS), and official government branding. When in doubt, use official government helplines or visit an e-Sevai centre.",
        },
      ],
    },
    ta: {
      title: "பொறுப்புத் துறப்பு",
      updated: "கவனமாகப் படிக்கவும்",
      sections: [
        {
          heading: "அரசு வலைத்தளம் அல்ல",
          body: "IndiaFees சுயாதீன தனியார் அடைவு. தமிழ்நாடு அரசு, இந்திய அரசு அல்லது எந்த அரசுத் துறையுடனும் தொடர்பில்லை; அங்கீகரிக்கப்படவில்லை.",
        },
        {
          heading: "பணம் கையாளுதல் இல்லை",
          body: "IndiaFees பணம் வசூலிப்பதில்லை, பெறுவதில்லை, செயலாக்குவதில்லை, சேமிப்பதில்லை அல்லது அனுப்புவதில்லை. அனைத்து கட்டணங்களும் அதிகாரப்பூர்வ அரசு வலைத்தளங்களில் அல்லது அங்கீகரிக்கப்பட்ட கட்டண வலைத்தளங்களில் நேரடியாக செலுத்தப்படும். நாங்கள் வங்கி, டிஜிட்டல் பணப்பை அல்லது கட்டண ஒருங்கிணைப்பாளர் அல்ல.",
        },
        {
          heading: "வெளி இணைப்புகள்",
          body: "இணைப்புகள் புதிய தாவலில் வெளித் தளங்களுக்குச் செல்லும். அந்த தளங்களின் உள்ளடக்கம், பாதுகாப்பு, கட்டணம் அல்லது கொள்கைக்கு நாங்கள் பொறுப்பல்ல.",
        },
        {
          heading: "உத்தரவாதம் இல்லை",
          body: "அடைவு “உள்ளபடி” வழங்கப்படுகிறது. முழுமை, துல்லியம் அல்லது தொடர்ச்சியான அணுகல் உத்தரவாதம் இல்லை.",
        },
        {
          heading: "பொறுப்பு வரம்பு",
          body: "சட்டப்படி அனுமதிக்கப்பட்ட முழு அளவிற்கு, இத்தளம் அல்லது இணைக்கப்பட்ட அரசு வலைத்தளங்களைப் பயன்படுத்துவதால் ஏற்படும் எந்த நஷ்டம் அல்லது சேதத்திற்கும், கட்டணப் பிழைகள், வெளித் தளங்களில் மோசடி அல்லது பழைய இணைப்புகள் உட்பட, IndiaFees மற்றும் அதன் இயக்குநர்கள் பொறுப்பல்ல.",
        },
        {
          heading: "உங்கள் சரிபார்ப்பு",
          body: "தனிப்பட்ட அல்லது கட்டணத் தகவல்களை உள்ளிடுவதற்கு முன், நீங்கள் சரியான அதிகாரப்பூர்வ வலைத்தளத்தில் இருப்பதை உறுதிசெய்வது உங்கள் பொறுப்பு. இணையதள முகவரி (URL), பாதுகாப்புச் சான்றிதழ் (HTTPS) மற்றும் அதிகாரப்பூர்வ அரசு அடையாளங்களை எப்போதும் சரிபார்க்கவும். சந்தேகம் இருந்தால், அதிகாரப்பூர்வ அரசு உதவி எண்கள் அல்லது e-Sevai மையத்தை அணுகவும்.",
        },
      ],
    },
  },
  hyperlinking: {
    en: {
      title: "Hyperlinking Policy",
      updated: "Linking to and from IndiaFees",
      sections: [
        {
          heading: "Linking to IndiaFees",
          body: "You may link to https://indiafees.com without prior permission, provided the link is fair, does not suggest endorsement or partnership, and does not frame our site inside another website.",
        },
        {
          heading: "Deep linking",
          body: "Linking to specific department or search pages is allowed. Do not misrepresent IndiaFees as an official government payment gateway.",
        },
        {
          heading: "Our outbound links",
          body: "IndiaFees links only to official government websites and authorised government payment portals. We do not knowingly link to unofficial payment agents or fee-charging intermediaries.",
        },
        {
          heading: "Link to government sites",
          body: "When you follow a link from IndiaFees, you are subject to that website’s terms, hyperlinking policy, and privacy policy. Many government sites restrict commercial reuse of their content.",
        },
        {
          heading: "Reporting misuse",
          body: "If someone uses the IndiaFees name or logo to run scams or fake payment pages, report it to contact@indiafees.com immediately.",
        },
        {
          heading: "Logo and brand",
          body: "The IndiaFees name and logo may not be used on other sites to imply government affiliation. Written permission is required for commercial reuse of our branding.",
        },
        {
          heading: "Link availability",
          body: "Government websites may change, move, or remove pages without prior notice. While we regularly review our links, we cannot guarantee that every external link will always be available, accurate, or up to date.",
        },
      ],
    },
    ta: {
      title: "இணைப்பு கொள்கை",
      updated: "IndiaFees-க்கும் அதிலிருந்தும் இணைப்பு",
      sections: [
        {
          heading: "IndiaFees-க்கு இணைப்பிடுதல்",
          body: "https://indiafees.com-க்கு முன் அனுமதி இல்லாமல் இணைப்பிடலாம். நியாயமான இணைப்பாக இருக்க வேண்டும்; அரசு/கூட்டாண்மை என்று தவறாகக் காட்டக்கூடாது; எங்கள் தளத்தை வேறு தளத்தில் frame செய்யக்கூடாது.",
        },
        {
          heading: "ஆழ இணைப்பு",
          body: "குறிப்பிட்ட துறை அல்லது தேடல் பக்கங்களுக்கு இணைப்பு அனுமதி. IndiaFees-யை அதிகாரப்பூர்வ அரசு கட்டண வாயிலாகத் தவறாகக் காட்ட வேண்டாம்.",
        },
        {
          heading: "வெளிச்செல்லும் இணைப்புகள்",
          body: "அதிகாரப்பூர்வ அரசு மற்றும் அங்கீகரிக்கப்பட்ட கட்டண தளங்களுக்கு மட்டுமே இணைப்பு. அங்கீகரிக்கப்படாத கட்டண முகவர்களுக்கு இணைப்பு இல்லை.",
        },
        {
          heading: "அரசுத் தள இணைப்புகள்",
          body: "IndiaFees இணைப்பைப் பின்தொடர்ந்தால் அந்த தளத்தின் பயன்பாட்டு நிபந்தனைகள், இணைப்பு கொள்கை மற்றும் தனியுரிமைக் கொள்கை பொருந்தும். பல அரசு தளங்கள் தங்கள் உள்ளடக்கத்தின் வணிக மறுபயன்பாட்டைக் கட்டுப்படுத்துகின்றன.",
        },
        {
          heading: "தவறான பயன்பாடு தெரிவித்தல்",
          body: "IndiaFees பெயர்/லோகோவைப் பயன்படுத்தி மோசடி அல்லது போலி கட்டணப் பக்கம் இருந்தால் contact@indiafees.com-க்கு உடனே தெரிவிக்கவும்.",
        },
        {
          heading: "லோகோ மற்றும் பிராண்ட்",
          body: "IndiaFees பெயர் மற்றும் லோகோவை அரசு தொடர்பு உள்ளது என்று வேறு தளங்களில் பயன்படுத்தக்கூடாது. வணிக மறுபயன்பாட்டிற்கு எழுத்து அனுமதி தேவை.",
        },
        {
          heading: "இணைப்பு கிடைப்பு",
          body: "அரசு வலைத்தளங்கள் முன்னறிவிப்பின்றி மாறலாம், நகரலாம் அல்லது பக்கங்களை நீக்கலாம். நாங்கள் எங்கள் இணைப்புகளை அவ்வப்போது சரிபார்த்தாலும், ஒவ்வொரு வெளிப்புற இணைப்பும் எப்போதும் கிடைக்கும், துல்லியமானது அல்லது புதுப்பித்த நிலையில் இருக்கும் என்று உத்தரவாதம் அளிக்க முடியாது.",
        },
      ],
    },
  },
};
